import { createRoot } from 'react-dom/client';
import { LandingNav } from '@/components/landing/LandingNav';

const mount = document.getElementById('site-nav');
if (mount) {
  createRoot(mount).render(<LandingNav />);
}

